/* eslint-disable @typescript-eslint/no-explicit-any */
import { Chips, LinkButton, Responsive, TDeviceType, Tooltip, TSliderValue } from '@cian/ui-kit';
import * as styles from './styles.css';
import { IncreaseUtp } from './components/IncreaseUtp';
import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis } from 'recharts';
import { TVas } from 'shared/types/vas';
import { RefObject } from 'react';
import { clsx } from 'clsx';
import { IconActionInfo24 } from '@cian/ui-kit-design-tokens/icons';
import { ALL_VAS } from 'shared/constants/vas';
import { MY_OFFERS } from 'shared/constants/links';
import { customizedGroupTick } from './utils/customizedGroupTick';
import { customLegend } from './utils/customLegend';

interface IIncreaseImpressionsProps extends TVas {
  onChangeActiveVas: (value: TSliderValue) => void;
  device: TDeviceType;
  viewsRef: RefObject<HTMLDivElement>;
}

export const IncreaseImpressions: React.FC<IIncreaseImpressionsProps> = ({
  vasId,
  title,
  maxIncrease,
  minIncrease,
  viewsRef,
  device,
  onChangeActiveVas,
}) => {
  const isDesktop = device === 'desktop';

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>Прирост уникальных показов</div>
        <Responsive desktop>
          <div className={styles['description']}>
            Чем сильнее продвижение, тем больше дополнительных показов получит объявление
          </div>
        </Responsive>
        <Responsive tablet phone>
          <IncreaseUtp />
        </Responsive>
      </div>
      <div className={styles['increase']}>
        <div className={styles['card-container']}>
          <div className={styles['chips']}>
            <Chips
              selectType="oneOf"
              value={[vasId]}
              onChipClick={e => onChangeActiveVas(e)}
              options={ALL_VAS.map(item => ({ value: item.vasId, label: item.title }))}
            />
          </div>
          <div id="card" className={styles['card']}>
            <div className={styles['card-title']}>{title}</div>
            <div className={styles['card-info']}>
              <div className={styles['card-info-title']}>Прирост показов</div>
              <div className={styles['card-points-container']}>
                <div ref={viewsRef} className={styles['card-info-points']}>
                  до 100
                </div>
                <div className={styles['tooltip']}>
                  <Tooltip title="Прогноз прироста показов носит иллюстративный характер. Точный прогноз вы увидите при подключении продвижения к вашему объявлению">
                    <IconActionInfo24 />
                  </Tooltip>
                </div>
              </div>
            </div>
            <div id="mapPinContainer" className={clsx(styles['card-map-pin'], 'animated-big-pin')} />
          </div>
        </div>
        <BarChart
          width={isDesktop ? 500 : 288}
          height={isDesktop ? 300 : 250}
          data={[
            { name: '27.03', default: 150 },
            { name: '28.03', default: 110, increase: maxIncrease },
            { name: '29.03', default: 150, increase: minIncrease },
          ]}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={customizedGroupTick} />
          <YAxis hide domain={[0, 700]} />
          <Legend
            content={customLegend}
            verticalAlign={isDesktop ? 'top' : 'bottom'}
            align={isDesktop ? 'center' : 'left'}
            wrapperStyle={{ top: isDesktop ? '-10px' : '', bottom: isDesktop ? '' : '0' }}
          />
          <Bar dataKey="default" name="Базовые показы" stackId="a" fill="#579FFF" barSize={150} />
          <Bar
            dataKey="increase"
            name="Показы от услуг продвижения"
            stackId="a"
            fill="#FFA552"
            style={{ transform: 'translate(0,-2px)', borderTopRightRadius: '10px' }}
            barSize={150}
          />
        </BarChart>
      </div>
      <Responsive desktop>
        <IncreaseUtp />
      </Responsive>
      <div className={styles['btn']}>
        <LinkButton size={device === 'desktop' ? 'L' : 'M'} href={MY_OFFERS} target="_blank" fullWidth>
          Подключить
        </LinkButton>
      </div>
    </div>
  );
};
